import React, { useState, useContext } from 'react';

import { useTranslation } from 'react-i18next';

import { useEditor, useNode } from '@craftjs/core';

import MyButton from '@common/components/Button/MyButton';

import LinkIcon from '@mui/icons-material/Link';

import LinkModal from './LinkModal';
import { normalizeUrl } from '@common/helpers/helpers';

export const getSelectedId = (selected) =>
  selected.size > 0 ? Array.from(selected)[0] : null;

export const getSelectedElement = (selectedId) => window.nodeRefs?.[selectedId];

const isNotSelected = (selection) => !selection || selection.rangeCount === 0;

const showModalInit = {
  show: false,
  selections: {
    range: null,
    selection: null,
    selectedElement: null,
    selectedId: null,
  },
};

const CreateLink = () => {
  const { selected } = useEditor((state) => ({
    selected: state.events.selected,
  }));
  const { t } = useTranslation();

  const [showModal, setShowModal] = useState(showModalInit);

  const {
    actions: { setProp },
  } = useNode();

  const onClick = () => {
    const selectedId = getSelectedId(selected);
    const selection = window?.getSelection();

    if (selectedId && !isNotSelected(selection)) {
      const selectedElement = getSelectedElement(selectedId);
      const range = selection.getRangeAt(0);

      if (!selectedElement.contains(range.commonAncestorContainer)) return;

      setShowModal({
        show: true,
        selections: {
          range: range,
          selection: selection,
          selectedElement: selectedElement,
          selectedId: selectedId,
        },
      });
    }
  };

  const onCancelClick = () => {
    setShowModal(showModalInit);
  };

  const onDialogOk = ({ url, label }) => {
    const { range, selection, selectedElement } = showModal.selections;
    const linkNode = document.createElement('a');

    linkNode.href = normalizeUrl(url);
    linkNode.textContent = label;
    linkNode.target = '_blank';
    linkNode.style.display = 'inline-block';

    const contentEditAttribute = document.createAttribute('contenteditable');
    contentEditAttribute.value = false;
    linkNode.setAttributeNode(contentEditAttribute);

    range.deleteContents();
    range.insertNode(linkNode);

    range.setStartAfter(linkNode);
    range.collapse(true);

    selection.removeAllRanges();
    selection.addRange(range);

    setProp((props) => {
      props.text = selectedElement.innerHTML;
    }, 500);

    setShowModal(showModalInit);
  };

  return (
    <>
      <LinkModal
        showModal={showModal}
        onOkClick={onDialogOk}
        onCancelClick={onCancelClick}
      />
      <MyButton
        color={'primary'}
        onMouseDown={onClick}
        startIcon={<LinkIcon />}
      >
        {t('create_link')}
      </MyButton>
    </>
  );
};

export default CreateLink;
